/**
 * WorkerByTn — БД (ТН) оруулж ажилтны мэдээллийг ТАТАХ талбар.
 *
 * Наряд зөвшөөрлийн маягтын 4-р хэсэгт «АЖИЛД ОРУУЛАГЧ», «АЖЛЫН
 * ХАРИУЦЛАГАТАЙ УДИРДАГЧ», «ЗӨВШӨӨРӨЛ ОЛГОГЧ» гэх мэт хүмүүсийг овог нэр,
 * албан тушаал, утасны дугаартай нь бичдэг. Гараар бичвэл:
 *   • нэг хүн олон янзаар бичигдэнэ (Б.Болдбаатар / Болдбаатар Б. …)
 *   • албан тушаал хуучирна
 *   • ТН байхгүй тул тайланд хүнээр нэгтгэх боломжгүй
 *
 * Тиймээс БД-г оруулаад ажилтны лавлахаас (getDicWorker) татна.
 *
 * Backend: GET /employee/<tn> — эрхийн хүрээнд шүүгддэг тул өөр цехийн
 * ажилтан татахад «Таны хамрах хүрээнд багтсангүй» гэж 406 буцаана.
 */
import React, { useState } from "react";
import { Input, Button, Tooltip, Tag } from "antd";
import { SearchOutlined, CloseOutlined, LoadingOutlined } from "@ant-design/icons";

import * as REQ from "src/api/request";

/**
 * props:
 *   tn, name, position   — одоогийн утгууд
 *   onChange({ tn, name, position, phone, unit })
 *   disabled, label
 */
export default function WorkerByTn({
  tn,
  name,
  position,
  onChange,
  disabled,
  placeholder = "БД (ТН)",
}) {
  const [input, setInput] = useState(tn || "");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [unit, setUnit] = useState("");
  const [phone, setPhone] = useState("");

  const fetchWorker = () => {
    const v = String(input || "").trim();
    if (!v) return;
    setLoading(true);
    setErr("");
    REQ.getSearchWorkerList(v)
      .then((w) => {
        if (!w || !w.shortname) {
          setErr("Ажилтан олдсонгүй");
          return;
        }
        const u =
          w.negj_namemn || w.tseh_namemn || w.department_name || "";
        setUnit(u);
        setPhone(w.p_mob || w.p_dom || "");
        onChange?.({
          tn: String(w.tn || v),
          name: w.shortname,
          position: w.position_namemn || "",
          phone: w.p_mob || w.p_dom || "",
          unit: u,
        });
      })
      .catch((e) => {
        // 406 — олдсонгүй эсвэл эрхийн хүрээнд байхгүй
        setErr(
          e?.response?.data?.message ||
            "Олдсонгүй эсвэл таны хамрах хүрээнд байхгүй",
        );
      })
      .finally(() => setLoading(false));
  };

  const clear = () => {
    setInput("");
    setErr("");
    setUnit("");
    setPhone("");
    onChange?.({ tn: null, name: null, position: null, phone: null, unit: null });
  };

  return (
    <div className="w-full">
      <div className="flex gap-2 items-center">
        <Input
          className="text-xs"
          style={{ width: 120 }}
          placeholder={placeholder}
          disabled={disabled}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onPressEnter={fetchWorker}
          onBlur={() => {
            // Шинэ БД бичсэн бол автоматаар татна
            if (input && String(input) !== String(tn || "")) fetchWorker();
          }}
        />
        <Tooltip title="Татах">
          <Button
            size="small"
            disabled={disabled || !input}
            icon={loading ? <LoadingOutlined /> : <SearchOutlined />}
            onClick={fetchWorker}
          />
        </Tooltip>

        {name ? (
          <span className="flex items-center gap-2 flex-1 min-w-0">
            <b className="text-xs">{name}</b>
            {position ? (
              <span className="text-[11px] text-gray-500 truncate">
                {position}
              </span>
            ) : null}
            {phone ? (
              <Tag style={{ margin: 0, fontSize: 10 }}>{phone}</Tag>
            ) : null}
            {!disabled && (
              <Tooltip title="Цэвэрлэх">
                <CloseOutlined
                  onClick={clear}
                  style={{ color: "#C4C9D1", cursor: "pointer", fontSize: 11 }}
                />
              </Tooltip>
            )}
          </span>
        ) : (
          <span className="text-[11px] text-gray-400">
            БД оруулаад Enter дарна уу
          </span>
        )}
      </div>
      {unit ? (
        <div className="text-[10px] text-gray-400 mt-0.5">{unit}</div>
      ) : null}
      {err ? (
        <div className="text-[11px] text-red-500 mt-0.5">{err}</div>
      ) : null}
    </div>
  );
}
